import { useState } from "react";
import { MotionBox as Box, fade } from "utils/motion";

const arrowStyle = (left, disable) => ({
  width: "44px",
  height: "44px",
  position: "absolute",
  transform: left ? "translateY(-22px)" : "translateY(-22px) rotate(180deg)",
  cursor: disable ? "not-allowed" : "pointer",
  opacity: disable ? 0.5 : 1,
});

export default function SliderThumbArrow({ left, right, onClick, disable }) {
  const [hovering, setHovering] = useState(false);

  return (
    <Box
      top="50%"
      left={left ? "24px" : null}
      right={right ? "24px" : null}
      onClick={onClick}
      onHoverStart={() => setHovering(true)}
      onHoverEnd={() => setHovering(false)}
      style={arrowStyle(left, disable)}
    >
      <Box
        variants={fade}
        initial="hidden"
        animate={hovering ? "visible" : "hidden"}
      >
        <ArrowIconHovered />
      </Box>
      <Box
        variants={fade}
        initial="normal"
        animate={hovering ? "hidden" : "visible"}
      >
        <ArrowIcon />
      </Box>
    </Box>
  );
}

const ArrowIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    viewBox="0 0 48 48"
    {...props}
  >
    <defs>
      <filter id="prefix__a" colorInterpolationFilters="auto">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter
        id="prefix__b"
        width="183.3%"
        height="183.3%"
        x="-41.7%"
        y="-41.7%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={4}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g
      filter="url(#prefix__a)"
      transform="translate(-849 -392)"
      fill="none"
      fillRule="evenodd"
    >
      <g filter="url(#prefix__b)" transform="matrix(-1 0 0 1 897 392)">
        <path
          fill="#252C32"
          d="M24 3C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21c0-5.57-2.212-10.911-6.15-14.85A21.009 21.009 0 0024 3zm0 40.5C13.23 43.5 4.5 34.77 4.5 24S13.23 4.5 24 4.5 43.5 13.23 43.5 24A19.5 19.5 0 0124 43.5z"
          opacity={0.4}
        />
        <path
          fill="#FFF"
          d="M21.18 13.935l-2.115 2.13L27 24l-7.935 7.935 2.115 2.13 7.935-7.95a3 3 0 000-4.23l-7.935-7.95z"
        />
      </g>
    </g>
  </svg>
);

const ArrowIconHovered = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    viewBox="0 0 48 48"
    style={{ transform: "rotate(180deg)", position: "absolute" }}
    {...props}
  >
    <defs>
      <filter id="prefix__a" colorInterpolationFilters="auto">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter
        id="prefix__b"
        width="183.3%"
        height="183.3%"
        x="-41.7%"
        y="-41.7%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={4}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g
      filter="url(#prefix__a)"
      transform="translate(-2025 -392)"
      fill="none"
      fillRule="evenodd"
    >
      <g filter="url(#prefix__b)" transform="translate(2025 392)">
        <path
          fill="#FFF"
          d="M24 3c5.57 0 10.911 2.212 14.85 6.15A21.009 21.009 0 0145 24c0 11.598-9.402 21-21 21S3 35.598 3 24 12.402 3 24 3zm-2.82 10.935l-2.115 2.13L27 24l-7.935 7.935 2.115 2.13 7.935-7.95a3 3 0 000-4.23l-7.935-7.95z"
        />
      </g>
    </g>
  </svg>
);
